import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons';

// Builds the address in the browser so it never appears as a plain
// "name@domain" string in the HTML or the JS bundle (keeps scrapers out).
const DOMAIN = 'gro.zenunorutra';

function reveal (reversed) {
    return reversed.split('').reverse().join('');
}

function copyFallback (text) {
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'absolute';
    field.style.left = '-9999px';
    document.body.appendChild(field);
    field.select();
    document.execCommand('copy');
    document.body.removeChild(field);
}

function EmailComponent (props) {
    const address = reveal(props.user) + String.fromCharCode(64) + reveal(DOMAIN);
    const [copied, setCopied] = useState(false);

    const copy = () => {
        const done = () => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1800);
        };
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(address.toLowerCase()).then(done, () => {
                copyFallback(address.toLowerCase());
                done();
            });
        } else {
            copyFallback(address.toLowerCase());
            done();
        }
    };

    if (props.noCopy) {
        return <span className={props.className}>{address}</span>;
    }

    return(
        <span className={'email ' + (props.className || '')}>
            <span className='email-address'>{address}</span>
            <button type='button' className={'email-copy' + (copied ? ' copied' : '')} onClick={copy}
                title='Copy email address' aria-label={'Copy email address ' + address}>
                <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
                <span className='email-copy-label' aria-live='polite'>{copied ? 'Copied' : 'Copy'}</span>
            </button>
        </span>
    );
}

export default EmailComponent;
